import { useEffect, useState } from "react";
import { Button, Input, Modal, Popconfirm, Space, TablePaginationConfig, message } from "antd";
import Table, { ColumnType } from "antd/es/table";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { FilterItem, FilterItemLabel, TableWrapper, TenantDevicesWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./TenantDevices.styled";
import TenantDeviceApi from "../../api/TenantDeviceApi";
import DeviceStatus from "../../components/ui-components/device-status/DeviceStatus";
import DeviceRssi from "../../components/ui-components/rssi/DeviceRssi";
import AddTenantDevice from "../tenant-management/components/tenant-details/components/tenant-devices/add-tenant-devices/AddTenantDevice";
import StringUtils from "../../util/StringUtils";
import TenantDetailDetails from "../tenant-management/components/tenant-details/components/tenant-devices/tenant-device-details.tsx/TenantDeviceDetails";


interface TenantDevicesProps {
}

interface TableParams {
    pagination?: TablePaginationConfig;
}

const TenantDevices: React.FC<TenantDevicesProps> = (props)=> {

    // api
    let tenantDeviceApi = new TenantDeviceApi();
    let [messageApi, contextHolder] = message.useMessage();

    // state
    let [tenantDevices, setTenantDevices] = useState<any[]>([]);
    let [search, setSearch] = useState<string>("");
    let [loading, setLoading] = useState<boolean>(false);
    let [openAddDeviceModal, setOpenAddDeviceModal] = useState<boolean>(false);
    let [openTenantDeviceDetailsModal, setOpenTenantDeviceDetailsModal] = useState<boolean>(false);
    let [selectedTenantDevice, setSelectedTenantDevice] = useState<any>(undefined);
    let [tableParams, setTableParams] = useState<TableParams>({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });

    let loadTenantDevices = async ()=> {
        let tenantDevicePage = (await tenantDeviceApi.queryTenantDeviceViews(
            '',
            search,
            tableParams.pagination?.current,
            tableParams.pagination?.pageSize,
        )).data.data;
        setTenantDevices(tenantDevicePage.elements);
        
        let newTableParams = {pagination: {...tableParams.pagination}};
        newTableParams.pagination.total = tenantDevicePage.totalElements;
        setTableParams(newTableParams);
    };

    useEffect(()=> {
        loadTenantDevices();
    }, []);
    
    // event
    
    let onViewTenantDeviceDetails = (tenantDeviceView)=> {
        setSelectedTenantDevice(tenantDeviceView);
        setOpenTenantDeviceDetailsModal(true);
    };

    let onAddDeviceClick = ()=> {
        setOpenAddDeviceModal(true);
    };

    let onDeleteDeviceClick = async (tenantDevice: any)=> {
        await tenantDeviceApi.removeTenantDevice(tenantDevice.tenantNodeMapping.tenantId, tenantDevice.tenantNodeMapping.nodeSn);
        loadTenantDevices();
        messageApi.open({
            type: 'success',
            content: '删除成功',
        });
    };

    let onSearchKeyDown = (e: any)=> {
        if (e.key === 'Enter') {
            loadTenantDevices()
        }
    };

    let onTableChange = (pagination)=> {
        tableParams.pagination = pagination;
        setTableParams({pagination: pagination});
        loadTenantDevices();
    };

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '设备名称',
            dataIndex: 'device.name',
            key: 'device.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> onViewTenantDeviceDetails(record)}>{StringUtils.emptyToSlash(record.device?.name)}</a>
            }
        },
        {
            title: '序列号 SN',
            dataIndex: 'tenantNode.sn',
            key: 'tenantNode.sn',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.tenantNode.sn}</span>
            }
        },
        {
            title: '租户',
            dataIndex: 'tenant.name',
            key: 'tenant.name',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.tenant?.name)}</span>
            }
        },
        {
            title: '设备状态',
            dataIndex: 'tenantNode.status',
            key: 'tenantNode.status',
            align: 'center',
            render: (text, record, index)=> {
                return record.tenantNode ? <span><DeviceStatus status={record.tenantNode?.status} /></span> : <span>N/A</span>
            }
        },
        {
            title: '信号强度',
            dataIndex: 'tenantNode.rssi',
            key: 'tenantNode.rssi',
            align: 'center',
            render: (text, record, index)=> {
                return record.tenantNode ? <span><DeviceRssi deviceRssi={record.tenantNode?.rssi} /></span> : <span>N/A</span>
            }
        },
        {
            title: '固件版本',
            dataIndex: 'tenantNode.firmwareVersion',
            key: 'tenantNode.firmwareVersion',
            align: 'center',
            render: (text, record, index)=> {
                return record.tenantNode ? <span>{record.tenantNode?.firmwareVersion}</span> : <span>N/A</span>
            }
        },
        {
            title: '最后在线时间',
            dataIndex: 'tenantNode.lastSeenTime',
            key: 'tenantNode.lastSeenTime',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{ record.tenantNode?.lastSeenTime ? moment(parseInt(record.tenantNode?.lastSeenTime)).format("YYYY-MM-DD HH:mm:ss") : 'N/A' }</span>
            }
        },
    ];

    return <TenantDevicesWrapper>
        {contextHolder}
        <ToolBarWrapper>
            <ToolBarLeftWrapper>
                <Space size="middle">
                    {/* <Button type="primary" onClick={onAddDeviceClick}>添加设备</Button> */}
                </Space>
            </ToolBarLeftWrapper>

            <ToolBarRightWrapper>
                <Space size="middle">
                    <FilterItem>
                        <FilterItemLabel>搜索</FilterItemLabel>
                        <Input
                            placeholder="请输入关键字"
                            suffix={<SearchOutlined />}
                            size="middle"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => onSearchKeyDown(e)}
                        />
                    </FilterItem>
                </Space>
            </ToolBarRightWrapper>

            <Modal open={openAddDeviceModal}
                afterClose={() => setOpenAddDeviceModal(false)}
                footer={null}
                closable={false}
                destroyOnClose={true}
                width={1000}
                height={600}
            >
                <AddTenantDevice onClose={() => setOpenAddDeviceModal(false)} onComplete={() => loadTenantDevices()} />
            </Modal>

            <Modal open={openTenantDeviceDetailsModal}
                afterClose={() => setOpenTenantDeviceDetailsModal(false)}
                cancelButtonProps={{style: {display: 'none'}}}
                closable={false}
                destroyOnClose={true}
                onOk={() => setOpenTenantDeviceDetailsModal(false)}
                width={800}
                height={600}
            >
                <TenantDetailDetails tenantDeviceView={selectedTenantDevice} />
            </Modal>
        </ToolBarWrapper>
        <TableWrapper>
            <Table
                rowKey={(record) => record.tenantNode.sn}
                columns={columns}
                dataSource={tenantDevices}
                pagination={tableParams.pagination}
                loading={loading}
                onChange={onTableChange}
            />
        </TableWrapper>

    </TenantDevicesWrapper>
}

export default TenantDevices;